import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TitleStrategy, RouterStateSnapshot } from "@angular/router";
import { BehaviorSubject, map, merge } from "rxjs";

@Injectable({ providedIn: 'root' })
export class WebdisplayPageTitleStrategy extends TitleStrategy {

  private prefix: BehaviorSubject<string> = new BehaviorSubject<string>('Adas');
  private preSplitter: BehaviorSubject<string> = new BehaviorSubject<string>(' | ');
  private currentTitle: BehaviorSubject<string> = new BehaviorSubject<string>('Web Display');
  private postSplitter: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private suffix: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(private readonly title: Title) {
    super();
    const combinedSubjects$ = merge(
      this.prefix,
      this.preSplitter,
      this.currentTitle,
      this.postSplitter,
      this.suffix
    );
    // Suscribirse al observable combinado y llamar a updateTitle cuando emita un nuevo valor
    combinedSubjects$.pipe(
      map(() => ({} as RouterStateSnapshot)) // Puedes pasar el estado del router necesario
    ).subscribe(snapshot => {
      this.updateTitle(snapshot);
    });
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const prefix = this.prefix.getValue();
    const preSplitter = this.preSplitter.getValue();
    let currentTitle = this.currentTitle.getValue();
    const postSplitter = this.postSplitter.getValue();
    const suffix = this.suffix.getValue();
    let title = this.buildTitle(routerState);
    if (title != undefined && title != null) {
      this.currentTitle.next(title);
      this.title.setTitle((`${prefix}${preSplitter}${title}${postSplitter}${suffix}`).trim());
    } else {
      this.title.setTitle((`${prefix}${preSplitter}${currentTitle}${postSplitter}${suffix}`).trim());
    }
  }

  setPrefix(prefix: string) {
    this.prefix.next(prefix);
  }

  setPreSplitter(splitter: string) {
    this.preSplitter.next(splitter);
  }

  setNewTitle(title: string) {
    this.currentTitle.next(title);
  }

  setPostSplitter(splitter: string) {
    this.postSplitter.next(splitter);
  }

  setSuffix(suffix: string) {
    this.suffix.next(suffix);
  }

  setupTitle(title: TitleItem) {
    if (title.prefix != null && title.prefix != undefined) this.setPrefix(title.prefix);
    if (title.preSplitter != null && title.preSplitter != undefined) this.setPreSplitter(title.preSplitter);
    if (title.currentTitle != null && title.currentTitle != undefined) this.setNewTitle(title.currentTitle);
    if (title.postSplitter != null && title.postSplitter != undefined) this.setPostSplitter(title.postSplitter);
    if (title.suffix != null && title.suffix != undefined) this.setSuffix(title.suffix);
  }

}

interface TitleItem {
  prefix?: string
  preSplitter?: string
  currentTitle?: string
  postSplitter?: string
  suffix?: string
}
